import { Box, Grid } from "@mui/material";
import React, { Component } from "react";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtCmb from "./CustomTool/CtCmb";
import CtBtn from "./CustomTool/CtBtn";
import TableList from "./CustomTool/TableList";
import { Edit, Delete, RefreshOutlined } from "@mui/icons-material";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { withRouter } from "../HOC/withRouter";
import OrderItemEntry from "./OrderItemEntry";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import Progress from "./CustomTool/Progress";
import {
  fetchCustomerMaster,
  apiURL,
  fetchOrder,
  fetchItemMaster,
} from "./API";
import {
  get_YMD_from_SYS,
  applyTrimOnObjectValues,
  validatedate_min_max,
  isValidItem,
  getRowData,
  getRoundOff,
} from "../SystemUtility/SystemUtility";
import CustomerMaster from "./CustomerMaster";
import ReferenceMaster from "./ReferenceMaster";

class OrderEntry extends Component {
  state = {
    Customer: [],
    ReferenceList: [],
    LedgerNameList: [],
    CustomerStateCode: "",
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      // { id: 'bint_srno', label: 'SR NO' },
      { id: "bint_itemsrno", label: "Sr. No." },
      { id: "vac_itemname", label: "Item Name" },
      { id: "vac_hsncode", label: "HSN" },
      { id: "vac_unit", label: "Packing" },
      { id: "dec_qty", label: "Quantity" },
      // { id: "dec_rate", label: "Pur Rate" },
      { id: "dec_rate", label: "Rate" },
      { id: "dec_basicamt", label: "Basic Amt" },
      { id: "dec_disper", label: "Dis (%)" },
      { id: "disamt", label: "Dis Amt" },
      { id: "dec_taxable", label: "Taxable" },
      { id: "vac_taxname", label: "Tax Name" },
      { id: "dec_cgstamt", label: "CGST" },
      { id: "dec_sgstamt", label: "SGST" },
      { id: "dec_igstamt", label: "IGST" },
      { id: "dec_totalamt", label: "Total Amount" },
      { id: "vac_remark", label: "Remark" },
      { id: "vac_storename", label: "Store Name", hide: true },
    ],
    keyColumn: [
      "bint_itemsrno", //0
      "vac_itemname", //1
      "vac_hsncode", //2
      "vac_unit", //3
      "dec_qty", //4
      "dec_rate", //5
      "dec_basicamt", //6
      "dec_disper", //7
      "dec_disamt", //8
      "dec_taxable", //9
      "vac_taxname", //10
      "dec_cgstamt", //11
      "dec_sgstamt", //12
      "dec_igstamt", //13
      "dec_totalamt", //14
      "vac_remark", //15
      "vac_storename", //16
    ],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "OrderEntry:",
        actionType: "AlertResponsive",
        visiblecondition: [
          { colID: "DisableEdit", value: false, relationalOperator: "==" },
        ],
        // hide: (this.props.userPrivilege.Sales == 'R' || this.props.userPrivilege.Sales == 'W')
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "OrderEntry:",
        actionType: "AlertResponsive",
        hide:
          this.props.userPrivilege.Sales == "R" ||
          this.props.userPrivilege.Sales == "W",
        visiblecondition: [
          { colID: "DisableDelete", value: false, relationalOperator: "==" },
        ],
      },
    ],
    formData: {
      edit_ordersrno: "",
      dtpDate: get_YMD_from_SYS(new Date()),
      cmbCompany: "",
      cmbCustomer: "",
      cmbreference: "",
      cmbLedgername: "",
      txtDiscount: "",
      txtTotalAmount: "",
      txtOrderNo: "",
      txtDiscount: "",
      txtTaxable: "",
      txtCGST: "",
      txtSGST: "",
      txtIGST: "",
      txtGrandTotal: "",
      txtRoundOff: "",
      txtRemark: "",
      int_status: 0,
    },
    autoResetFormData: false,
    rows: [],
    rowsCount: 0,
    counter: 0,
    ARD: null,
    searchData: {
      bint_itemsrno: "",
      vac_storename: "",
      vac_itemname: "",
      vac_hsncode: "",
      vac_unit: "",
      dec_qty: "",
      dec_rate: "",
      dec_basicamt: "",
      dec_disper: "",
      dec_disamt: "",
      dec_taxable: "",
      vac_taxname: "",
      dec_cgstamt: "",
      dec_sgstamt: "",
      dec_igstamt: "",
      dec_totalamt: "",
      vac_remark: "",
    },
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    rowsPerPage: 5,
    searchRowsCount: 0,
    dataLoadStatus: true,
    rowsOtherDetail: [],
    rowsCountOtherDetail: 0,
    rowsPerPageOtherDetail: 10,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Order Entry";
    this.props.setActiveMenu("OrderEntry");
    this.setSearchColumns();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus, autoResetFormData: false }, () => {
      // console.log(
      //   "182 : this.state.autoResetFormData",
      //   this.state.autoResetFormData
      // );
      // console.log("this.props.location", this.props.location);
      // console.log("this.props.location.state", this.props.location.state);
      let bint_acyear = 0,
        bint_acid = 0,
        edit_ordersrno = 0;
      if (this.props.location.state && this.props.location.state != null) {
        // var editInfo = this.props.params.EditOrderSrNo.split(":");
        bint_acid = this.props.location.state.bint_acid;
        edit_ordersrno = this.props.location.state.bint_ordersrno;
        bint_acyear = this.props.location.state.bint_acyear;
      }
      let reqData = {
        Op: "OrderData",
        bint_acyear: localStorage.getItem("ACY"),
        bint_acid: localStorage.getItem("acid"),
        edit_ordersrno: edit_ordersrno,
      };
      fetchOrder(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
          let Customer = res.data.CustomerList,
            TaxNameList = res.data.TaxList,
            ItemNameList = res.data.ItemList,
            ReferenceList = res.data.ReferenceList,
            LedgerNameList = res.data.LedgerNameList,
            rows = [],
            rowsCount = rows.length;
          if (res.data.ItemData && res.data.ItemData.length > 0) {
            rows = this.addActionColStatus(res.data.ItemData);
            rowsCount = rows.length;
          }
          if (res.data.OrderList && res.data.OrderList.length > 0) {
            // console.log("OrderList", res.data.OrderList);
            // console.log(
            //   "res.data.OrderList[0].vac_referencename",
            //   res.data.OrderList[0].vac_referencename
            // );
            this.setState(
              {
                dataLoadStatus: true,
                Customer,
                TaxNameList,
                ItemNameList,
                ReferenceList,
                LedgerNameList,
                rows,
                rowsCount,
                formData: {
                  ...this.state.formData,
                  edit_ordersrno: res.data.OrderList[0].bint_ordersrno,
                  txtOrderNo: res.data.OrderList[0].bint_ordersrno,
                  dtpDate: res.data.OrderList[0].dat_orderdate,
                  cmbCompany: res.data.OrderList[0].vac_company,
                  cmbCustomer: res.data.OrderList[0].vac_customer,
                  cmbreference: res.data.OrderList[0].vac_referencename,
                  cmbLedgername: res.data.OrderList[0].vac_ledgername,
                  txtDiscount: res.data.OrderList[0].dec_discountamount,
                  txtTaxable: res.data.OrderList[0].dec_taxable,
                  txtCGST: res.data.OrderList[0].dec_cgst,
                  txtSGST: res.data.OrderList[0].dec_sgst,
                  txtIGST: res.data.OrderList[0].dec_igst,
                  txtGrandTotal: res.data.OrderList[0].dec_grandtotal,
                  txtRoundOff: res.data.OrderList[0].dec_roundoff,
                  txtTotalAmount: res.data.OrderList[0].dec_totalamount,
                  txtRemark: res.data.OrderList[0].vac_remark,
                  int_status: res.data.OrderList[0].int_status,
                },
              },
              () => {
                // console.log("this.state.formData", this.state.formData);
              }
            );
          } else {
            this.setState(
              {
                dataLoadStatus: true,
                autoResetFormData: true,
                Customer,
                TaxNameList,
                ItemNameList,
                ReferenceList,
                LedgerNameList,
                rows,
                rowsCount,
              },
              () => {
                // console.log(ReferenceList)
              }
            );
            // console.log(LedgerNameList)
          }
        })
        .catch((error) => {
          this.props.toastMsg(
            "error",
            "Unkonwn Error occured in onFormLoad. " + error
          );
        });
    });
    document.getElementById("cmbCustomer").focus();
  };

  addActionColStatus = (rows) => {
    const newRows = rows.map((row) => {
      const actionStatus = this.DisableOnEditDelete(row.int_status, true);
      return {
        ...row,
        DisableDelete: actionStatus.DisableDelete,
        DisableEdit: actionStatus.DisableEdit,
      };
    });
    return newRows;
  };

  DisableOnEditDelete = (int_status, returnStatus = undefined) => {
    let DisableDelete = false,
      DisableEdit = false;
    if (int_status == 0) {
      DisableDelete = false;
      DisableEdit = false;
    } else {
      DisableDelete = true;
      DisableEdit = true;
    }
    if (returnStatus) {
      return {
        DisableDelete,
        DisableEdit,
      };
    } else {
      this.setState(
        {
          DisableDelete,
          DisableEdit,
        },
        () => {}
      );
    }
  };

  //#endregion Component

  //#region Handle
  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    // console.log("outsideif")
    // console.log("searchOpen === true && this.state.rows.length > 0", searchOpen === true && this.state.rows.length > 0)
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        // console.log("row", row);
        if (
          searchOpen === true &&
          // (this.state.searchData.bint_ordersrno.length === 0 ||
          //   (row["bint_ordersrno"] &&
          //       row["bint_ordersrno"]
          //           .toString()
          //           .toLowerCase()
          //           .includes(this.state.searchData.bint_ordersrno.toLowerCase()))) &&
          (this.state.searchData.vac_itemname.length === 0 ||
            (row["vac_itemname"] &&
              row["vac_itemname"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_itemname.toLowerCase()))) &&
          (this.state.searchData.vac_hsncode.length === 0 ||
            (row["vac_hsncode"] &&
              row["vac_hsncode"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_hsncode.toLowerCase()))) &&
          (this.state.searchData.vac_unit.length === 0 ||
            (row["vac_unit"] &&
              row["vac_unit"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_unit.toLowerCase()))) &&
          (this.state.searchData.dec_qty.length === 0 ||
            (row["dec_qty"] &&
              row["dec_qty"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_qty.toLowerCase()))) &&
          (this.state.searchData.dec_rate.length === 0 ||
            (row["dec_rate"] &&
              row["dec_rate"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_rate.toLowerCase()))) &&
          (this.state.searchData.dec_totalamt.length === 0 ||
            (row["dec_totalamt"] &&
              row["dec_totalamt"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_totalamt.toLowerCase()))) &&
          (this.state.searchData.vac_remark.length === 0 ||
            (row["vac_remark"] &&
              row["vac_remark"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_remark.toLowerCase())))
        ) {
          searchRows.push(row);
          // console.log("searchRows push", searchRows);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {
          // console.log('searchRows on end of Function', searchRows)
        }
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  onDeleteBtnClick = () => {
    // console.log("this.state.formData.edit_ordersrno", this.state.formData.edit_ordersrno)
    if (this.state.formData.edit_ordersrno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Order No. : " +
              this.state.formData.edit_ordersrno +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.deleteOrder(this.state.formData.edit_ordersrno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("There are no Order to delete", "dtpDate");
    }
  };

  deleteOrder = (edit_ordersrno) => {
    if (edit_ordersrno > 0) {
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus: false }, () => {
        const reqData = {
          Op: "DeleteOrder",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          edit_ordersrno: edit_ordersrno,
          dat_fromdate: "",
          dat_todate: "",
        };
        fetchOrder(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              this.setState({ ARD: null, dataLoadStatus: true }, () => {
                this.clearInfo();
              });
            } else {
              this.setState({ dataLoadStatus: true });
            }
          })
          .catch((error) => {
            this.props.updateProcessing(
              "error",
              "Unknown error occurred in delete deleteOrder. " + error
            );
          });
      });
    } else {
      this.props.notifyProcessing();
      this.props.updateProcessing(
        "error",
        "There are no Orders records to delete."
      );
    }
  };

  deleteOrderItem = (bint_acyear, bint_acid, edit_ordersrno, bint_itemsrno) => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "DeleteOrderItem",
        bint_acyear: bint_acyear,
        bint_acid: bint_acid,
        edit_ordersrno: edit_ordersrno,
        bint_itemsrno: bint_itemsrno,
      };
      // console.log("edit_ordersrno on delete order item", edit_ordersrno);
      fetchOrder(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = [],
            rowsCount = 0;
          let dec_basicamt = 0,
            dec_disamt = 0,
            dec_taxable = 0,
            dec_cgstamt = 0,
            dec_sgstamt = 0,
            dec_igstamt = 0,
            dec_totalamt = 0,
            ItemData = [];
          if (res.data.ItemData && res.data.ItemData.length > 0) {
            rows = this.addActionColStatus(res.data.ItemData);
            rowsCount = rows.length;
          }
          // console.log("res.data.ItemData", res.data.ItemData)
          // if (res.data.TotalItemAmountData) {
          //   dec_basicamt = Number(res.data.TotalItemAmountData[0].dec_basicamt);
          //   dec_disamt = Number(res.data.TotalItemAmountData[0].dec_disamt);
          //   dec_taxable = Number(res.data.TotalItemAmountData[0].dec_taxable);
          //   dec_cgstamt = Number(res.data.TotalItemAmountData[0].dec_cgstamt);
          //   dec_sgstamt = Number(res.data.TotalItemAmountData[0].dec_sgstamt);
          //   dec_igstamt = Number(res.data.TotalItemAmountData[0].dec_igstamt);
          //   dec_totalamt = Number(res.data.TotalItemAmountData[0].dec_totalamt);
          // }
          if (res.data.OrderList) {
            edit_ordersrno = res.data.OrderList[0].bint_ordersrno;
            dec_taxable = Number(res.data.OrderList[0].dec_taxable);
            dec_cgstamt = Number(res.data.OrderList[0].dec_cgst);
            dec_sgstamt = Number(res.data.OrderList[0].dec_sgst);
            dec_igstamt = Number(res.data.OrderList[0].dec_igst);
            dec_totalamt = Number(res.data.OrderList[0].dec_grandtotal);
          }
          this.resetAmount(
            dec_taxable,
            dec_cgstamt,
            dec_sgstamt,
            dec_igstamt,
            dec_totalamt,
            0,
            edit_ordersrno
          );
          this.setState({
            ARD: null,
            rows,
            rowsCount,
            dataLoadStatus,
          });
        })
        .catch((error) => {
          console.log("Unknown error occurred in deleteOrderList.", error);
        });
    });
    console.log(
      "this.state.formData.edit_ordersrno ondeleteorder item",
      this.state.formData.edit_ordersrno
    );
    return true;
  };

  refreshOrderItemList = (rows, rowsCount) => {
    rows = this.addActionColStatus(rows);
    this.setState(
      {
        rows,
        rowsCount,
      },
      () => {}
    );
  };

  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "cmbCustomer") {
          this.getStateCodeOFCustomer();
        }
      }
    );
  };

  getStateCodeOFCustomer = () => {
    if (
      this.state.formData.cmbCustomer.length > 0 &&
      this.state.autoResetFormData === true
    ) {
      this.state.Customer.map((row) => {
        if (row.vac_customer === this.state.formData.cmbCustomer) {
          this.setState({
            formData: {
              ...this.state.formData,
              cmbreference: row.vac_referencename,
            },
            CustomerStateCode: row.vac_statecode,
          });
        }
      });
    } else if (this.state.autoResetFormData === false) {
      this.setState({ autoResetFormData: true });
    }
  };

  getItemList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ItemList",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchItemMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Item List Loaded");
        let ItemNameList = res.data.ItemList;
        this.setState(
          {
            ItemNameList,
          },
          () => {}
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getItemList.", error);
      });
  };

  handleOnSearchInputChange = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen);
        console.log(this.state.searchData);
      }
    );
  };
  //#endregion

  //region function

  updateRefenceitemList = (ReferenceList) => {
    this.setState({ ReferenceList });
  };
  updateCustomeritemList = (CustomerList) => {
    this.setState({ CustomerList });
  };

  navigateTo = (link) => {
    this.props.navigate("/" + link);
  };

  handleOnNewEntryClick = () => {
    if (this.validateOrder() === true) {
      // console.log(this.state.CustomerStateCode)
      let GroupLedger = getRowData(
        this.state.LedgerNameList,
        "vac_ledgername",
        this.state.formData.cmbLedgername
      );
      // console.log("GroupLedger", GroupLedger)
      let vac_groupname = "";
      if (this.state.formData.cmbLedgername > 0) {
        vac_groupname = GroupLedger.vac_groupname;
      } else {
        vac_groupname = "";
      }
      let ARD = null;
      this.setState({ ARD }, () => {
        console.log(
          "this.state.formData.edit_ordersrno on handle on click",
          this.state.formData.edit_ordersrno
        );
        ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            autoFocusDisagreeButton={false}
            alertMessage={
              <OrderItemEntry
                refreshOrderItemList={this.refreshOrderItemList}
                resetAmount={this.resetAmount}
                getItemList={this.getItemList}
                bint_acid={localStorage.getItem("acid")}
                edit_ordersrno={this.state.formData.edit_ordersrno}
                vac_customer={this.state.formData.cmbCustomer}
                vac_referencename={this.state.formData.cmbreference}
                bint_acyear={localStorage.getItem("ACY")}
                cmbCompany={localStorage.getItem("CompanyName")}
                vac_groupname={vac_groupname}
                ItemNameList={this.state.ItemNameList}
                TaxNameList={this.state.TaxNameList}
                dtpDate={this.state.formData.dtpDate}
                txtDiscount={this.state.formData.txtDiscount}
                txtTaxable={this.state.formData.txtTaxable}
                txtCGST={this.state.formData.txtCGST}
                txtSGST={this.state.formData.txtSGST}
                txtIGST={this.state.formData.txtIGST}
                txtGrandTotal={this.state.formData.txtGrandTotal}
                CustomerStateCode={this.state.CustomerStateCode}
                txtRoundOff={this.state.formData.txtRoundOff}
                txtRemark={this.state.formData.txtRemark}
                txtTotalAmount={this.state.formData.txtTotalAmount}
              />
            }
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        console.log(
          "this.state.formData.edit_ordersrno",
          this.state.formData.edit_ordersrno
        );
        this.setState({ ARD });
      });
    }
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleARDonActionClick = (row) => {
    let bint_itemsrno = row.bint_itemsrno,
      vac_itemname = row.vac_itemname,
      actionName = row.actionName,
      edit_ordersrno = row.edit_ordersrno,
      bint_acyear = localStorage.getItem("ACY"),
      bint_acid = localStorage.getItem("acid"),
      EditOrderItemData = [];
    // CustomerStateCode = "";
    let GroupLedger = getRowData(
      this.state.LedgerNameList,
      "vac_ledgername",
      this.state.formData.cmbLedgername
    );
    // console.log("GroupLedger", GroupLedger)
    let vac_groupname = "";
    if (this.state.formData.cmbLedgername > 0) {
      vac_groupname = GroupLedger.vac_groupname;
    } else {
      vac_groupname = "";
    }

    if (actionName === "Edit") {
      let ARD = null;
      EditOrderItemData = [
        {
          bint_itemsrno: row.bint_itemsrno,
          vac_itemname: row.vac_itemname,
          vac_hsncode: row.vac_hsncode,
          vac_unit: row.vac_unit,
          dec_qty: row.dec_qty,
          dec_rate: row.dec_rate,
          dec_basicamt: row.dec_basicamt,
          dec_disper: row.dec_disper,
          dec_disamt: row.dec_disamt,
          dec_taxable: row.dec_taxable,
          vac_taxname: row.vac_taxname,
          dec_cgstamt: row.dec_cgstamt,
          dec_sgstamt: row.dec_sgstamt,
          dec_igstamt: row.dec_igstamt,
          dec_totalamt: row.dec_totalamt,
          vac_remark: row.vac_remark,
          vac_storename: row.vac_storename,
        },
      ];
      // console.log("EditOrderItemData", EditOrderItemData);
      this.setState({ ARD }, () => {
        console.log(
          "this.state.formData.edit_ordersrno on handle on click",
          this.state.formData.edit_ordersrno
        );
        ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            alertMessage={
              <OrderItemEntry
                bint_itemsrno={bint_itemsrno}
                edit_ordersrno={edit_ordersrno}
                getItemList={this.getItemList}
                refreshOrderItemList={this.refreshOrderItemList}
                resetAmount={this.resetAmount}
                bint_acid={localStorage.getItem("acid")}
                bint_acyear={localStorage.getItem("ACY")}
                ItemNameList={this.state.ItemNameList}
                PackingList={this.state.PackingList}
                TaxNameList={this.state.TaxNameList}
                StoreList={this.state.StoreList}
                EditOrderItemData={EditOrderItemData}
                dtpDate={this.state.formData.dtpDate}
                cmbCompany={localStorage.getItem("CompanyName")}
                vac_customer={this.state.formData.cmbCustomer}
                vac_groupname={vac_groupname}
                vac_referencename={this.state.formData.cmbreference}
                txtDiscount={this.state.formData.txtDiscount}
                txtTaxable={this.state.formData.txtTaxable}
                txtCGST={this.state.formData.txtCGST}
                txtSGST={this.state.formData.txtSGST}
                txtIGST={this.state.formData.txtIGST}
                txtGrandTotal={this.state.formData.txtGrandTotal}
                txtTotalAmount={this.state.formData.txtTotalAmount}
                txtRoundOff={this.state.formData.txtRoundOff}
                txtRemark={this.state.formData.txtRemark}
              />
            }
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else if (actionName === "Delete") {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={"Do you want to Delete Item : " + vac_itemname + " ?"}
            alertMessage=""
            handleOnClickYes={() => {
              return this.deleteOrderItem(
                bint_acyear,
                bint_acid,
                edit_ordersrno,
                bint_itemsrno
              );
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        console.log(
          "edit_ordersrno whene return true",
          this.state.formData.edit_ordersrno
        );

        this.setState({ ARD });
      });
    }
  };

  clearInfo = () => {
    // let cmbTransactionType = "";
    // if (
    //   this.state.DefaultEntrySettingList &&
    //   this.state.DefaultEntrySettingList.length > 0
    // ) {
    //   cmbTransactionType =
    //     this.state.DefaultEntrySettingList[0].vac_transacationtype;
    // }
    this.setState(
      {
        formData: {
          ...this.state.formData,
          edit_ordersrno: "",
          txtOrderNo: "",
          dtpDate: get_YMD_from_SYS(new Date()),
          // dtpDueDate: "",
          // cmbCompany: localStorage.getItem("CompanyName"),
          // cmbBillType: "",
          // txtBillNo: "",
          // LblBillNo: "",
          cmbCustomer: "",
          cmbreference: "",
          cmbLedgername: "",
          // cmbShipTo: "",
          // txtOtherDetail: "",
          txtDiscount: "",
          txtTaxable: "",
          txtCGST: "",
          txtSGST: "",
          txtIGST: "",
          txtGrandTotal: "",
          // txtTDSAmount: "",
          // txtAdvPayment: "",
          txtTotalAmount: "",
          txtRoundOff: "",
          // cmbTransactionType,
          txtRemark: "",
          int_status: 0,
          // chkReceiptGenerated: false,
        },
        rows: [],
        rowsCount: 0,
      },
      () => {
        document.getElementById("dtpDate").focus();
        this.props.navigateTo("OrderEntry");
      }
    );
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      // {
      //   cType: "CtTxt",
      //   id: "srno",
      //   label: "Sr. No.",
      //   value: this.state.searchData.srno,
      //   handleOnChange: this.handleOnSearchInputChange,
      //   width: "150",
      // },
      {
        cType: "Lbl",
        label: "Sr. No.",
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_itemname",
        label: "Item Name",
        value: this.state.searchData.vac_itemname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_hsncode",
        label: "HSN",
        value: this.state.searchData.vac_hsncode,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "10",
      },
      {
        cType: "CtTxt",
        id: "vac_unit",
        label: "Packing",
        value: this.state.searchData.vac_unit,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "10",
      },
      {
        cType: "CtTxt",
        id: "dec_qty",
        label: "Quantity",
        value: this.state.searchData.dec_qty,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "15",
      },
      {
        cType: "CtTxt",
        id: "dec_rate",
        label: "Rate",
        value: this.state.searchData.dec_rate,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "15",
      },
      {
        cType: "Lbl",
        label: "Basic Amt",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Dis (%)",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Dis Amt",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Taxable",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Tax Name",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "CGST",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "SGST",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "IGST",
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "dec_totalamt",
        label: "Total Amount",
        value: this.state.searchData.dec_totalamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_remark",
        label: "Remark",
        value: this.state.searchData.vac_remark,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "500",
      },
      {
        cType: "Lbl",
        label: "Store Name",
        width: "100",
      }
    );
    this.setState({ searchColumns });
  };

  trimFormData = (nextFunctionCall) => {
    // console.log("this.state.formData before SetSate", this.state.formData);
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      // console.log("this.state.formData After SetSate", this.state.formData);
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validateOrder = () => {
    let result = false;
    // console.log(applyTrimOnObjectValues(this.state.formData,['cmbCustomer']))
    if (this.state.formData.dtpDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpDate,
        "dtpDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return false;
    } /* else if (this.state.formData.cmbBillType.length <= 0) {
      this.props.toastErrorMsg("Select Bill Type", "cmbBillType");
    } else if (this.state.formData.txtBillNo.length <= 0) {
      this.props.toastErrorMsg("Enter Bill No", "txtBillNo");
    }  */ else if (this.state.formData.cmbCustomer.length <= 0) {
      this.props.toastErrorMsg("Select Customer Name", "cmbCustomer");
    } else if (
      isValidItem(
        this.state.Customer,
        "vac_customer",
        this.state.formData.cmbCustomer
      ) == false
    ) {
      this.props.toastErrorMsg("Select Valid Customer Name", "cmbCustomer");
    } /* else if (this.state.formData.cmbTransactionType.length <= 0) {
      this.props.toastErrorMsg("Select Transaction Type", "cmbTransactionType");
    } */ else {
      result = true;
    }
    return result;
  };

  getCustomerList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "LoadCustomerDetails",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchCustomerMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Customer List Loaded");
        let Customer = res.data.CustomerList;
        // ShipTo = res.data.CustomerList;
        this.setState(
          {
            Customer,
            // ShipTo,
          },
          () => {
            // console.log("this.state", this.state);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getCustomerList.", error);
      });
  };

  validateOrderItemCount = () => {
    // this.props.toastErrorMsg("validateSalesItemCount")
    let result = false;
    if (this.state.rowsCount <= 0) {
      this.props.toastErrorMsg("Enter atleast one item", "dtpDate");
    } else {
      result = true;
    }
    return result;
  };

  resetAmount = (
    txtTaxable,
    txtCGST,
    txtSGST,
    txtIGST,
    txtGrandTotal,
    txtDiscount,
    edit_ordersrno
  ) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtTaxable,
          txtCGST,
          txtSGST,
          txtIGST,
          txtGrandTotal,
          txtDiscount,
          edit_ordersrno,
        },
      },
      () => {
        // console.log("this.state.formData", this.state.formData);
        this.calNetAmount();
      }
    );
  };

  calNetAmount = () => {
    // console.log(Number(this.state.formData.txtGrandTotal))
    // console.log((this.state.formData.txtTotalAmount))
    let txtTotalAmount = Number(this.state.formData.txtGrandTotal),
      txtRoundOff = 0;
    // console.log(txtTotalAmount)
    let arrNetPayment = getRoundOff(txtTotalAmount);
    // console.log(arrNetPayment)
    txtTotalAmount = arrNetPayment["roff_number"];
    // console.log(txtTotalAmount)
    txtRoundOff = arrNetPayment["roff"];
    // console.log(txtRoundOff)
    this.setState({
      formData: {
        ...this.state.formData,
        txtTotalAmount,
        txtRoundOff,
        // chkReceiptGenerated,
      },
    });
  };

  saveOrderData = () => {
    if (this.validateOrder() && this.validateOrderItemCount()) {
      const dataLoadStatus = false;
      this.props.notifyProcessing();

      this.setState({ dataLoadStatus }, () => {
        let GroupLedger = getRowData(
          this.state.LedgerNameList,
          "vac_ledgername",
          this.state.formData.cmbLedgername
        );
        // console.log("GroupLedger", GroupLedger);
        const reqData = {
          Op: "SaveOrder_Item",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          vac_company: localStorage.getItem("CompanyName"),
          bint_ordersrno: this.state.formData.edit_ordersrno,
          dat_orderdate: this.state.formData.dtpDate,
          vac_groupname:
            GroupLedger.vac_groupname && GroupLedger.vac_groupname > 0
              ? GroupLedger.vac_groupname
              : "",
          vac_customer: this.state.formData.cmbCustomer,
          vac_ledgername:
            this.state.formData.cmbLedgername &&
            this.state.formData.cmbLedgername.length > 0
              ? this.state.formData.cmbLedgername
              : "",
          vac_referencename:
            this.state.formData.cmbreference &&
            this.state.formData.cmbreference.length > 0
              ? this.state.formData.cmbreference
              : "",
          dec_discountamount: this.state.formData.txtDiscount,
          dec_taxable: this.state.formData.txtTaxable,
          dec_cgst: this.state.formData.txtCGST,
          dec_sgst: this.state.formData.txtSGST,
          dec_igst: this.state.formData.txtIGST,
          dec_grandtotal: this.state.formData.txtGrandTotal,
          dec_roundoff: this.state.formData.txtRoundOff,
          dec_totalamount: this.state.formData.txtTotalAmount,
          vac_remark: this.state.formData.txtRemark,
          ItemData: [],
        };
        fetchOrder(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              this.setState(
                {
                  dataLoadStatus: true,
                },
                () => {
                  this.clearInfo();
                }
              );
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in saveOrder.", error);
          });
      });
    }
  };

  onAddClickReference = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // alertTitle={'Sales Item Entry'}
          alertMessage={
            <ReferenceMaster
              updateRefenceitemList={this.updateRefenceitemList}
              showHeading={true}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  // getCustomerList = () => {
  //   this.props.notifyProcessing();
  //   const reqData = {
  //     Op: "LoadCustomerDetails",
  //     bint_acid: localStorage.getItem("acid"),
  //   };
  //   fetchCustomerMaster(reqData)
  //     .then((res) => {
  //       this.props.updateProcessing("success", "Customer List Loaded");
  //       let Customer = res.data.CustomerList;
  //       this.setState(
  //         {
  //           Customer,
  //         },
  //         () => {
  //           // console.log("this.state", this.state);
  //         }
  //       );
  //     })
  //     .catch((error) => {
  //       console.log("Unknown error occurred in getCustomerList.", error);
  //     });
  // };

  onAddClickCustomer = () => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<CustomerMaster showHeading={true} />
          defaultOpenDialog={true}
          handleOnClickNo={this.getCustomerList}
        />
      );
      this.setState({ ARD });
    });
  };

  render() {
    // console.log(
    //   "this.state.formData.int_status",
    //   this.state.formData.int_status
    // );
    // console.log("this.props.edit_ordersrno", this.props.edit_ordersrno)
    // console.log("this.state.searchRows.render", this.state.searchRows);
    // console.log(
    //   "this.state.formData.cmbreference",
    //   this.state.formData.cmbreference
    // );
    const rows = this.state.searchOpen
      ? this.state.searchRows
      : this.state.rows;
    const rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;
    // console.log("this.state.rows", this.state.rows);
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Order Entry</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          spacing={2}
          marginTop={0}
          marginLeft={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              margin={0}
            >
              <Grid item>
                <CtTxtNum
                  id="txtOrderNo"
                  label="Order No"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtOrderNo}
                  width={120}
                  maxLength={10}
                  disabled={true}
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpDate"
                  label="Date*"
                  width="170"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpDate}
                  accountYear={localStorage.getItem("ACY")}
                  nextCtrlID={"cmbCustomer"}
                  onKeyDown={this.props.onKeyDown}
                  value={this.state.formData.dtpDate}
                />
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="cmbCustomer"
                  label="Customer*"
                  items={this.state.Customer}
                  value={this.state.formData.cmbCustomer}
                  handleOnChange={this.handleOnChange}
                  width={250}
                  maxLength={100}
                  colID="vac_customer"
                  bolVisibleOnAddClickIcon={
                    this.props.userPrivilege.Customer == "A" ? true : false
                  }
                  onAddClick={this.onAddClickCustomer}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbreference"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              margin={0}
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbreference"
                  label="Reference Name"
                  items={this.state.ReferenceList}
                  value={this.state.formData.cmbreference}
                  handleOnChange={this.handleOnChange}
                  width={250}
                  maxLength={100}
                  colID="vac_referencename"
                  bolVisibleOnAddClickIcon={
                    this.props.userPrivilege.Reference == "A" ? true : false
                  }
                  onAddClick={this.onAddClickReference}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbLedgername"
                />
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="cmbLedgername"
                  label="Delivery Responsible Person"
                  items={this.state.LedgerNameList}
                  value={this.state.formData.cmbLedgername}
                  handleOnChange={this.handleOnChange}
                  colID="vac_ledgername"
                  width={300}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtRemark"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              margin={0}
            >
              <Grid item>
                <CtTxtAmt
                  id="txtDiscount"
                  label="Discount Amount"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtDiscount}
                  width={160}
                  disabled={true}
                  maxLength={10}
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtTaxable"
                  label="Taxable"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtTaxable}
                  disabled={true}
                  width={100}
                  maxLength={10}
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtCGST"
                  label="CGST"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtCGST}
                  disabled={true}
                  width={100}
                  maxLength={10}
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtSGST"
                  label="SGST"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtSGST}
                  disabled={true}
                  width={100}
                  maxLength={10}
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtIGST"
                  label="IGST"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtIGST}
                  disabled={true}
                  width={100}
                  maxLength={10}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              margin={0}
            >
              <Grid item>
                <CtTxtAmt
                  id="txtGrandTotal"
                  label="Grand Total"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtGrandTotal}
                  disabled={true}
                  width={130}
                  maxLength={10}
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtRoundOff"
                  label="Round Off"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtRoundOff}
                  disabled={true}
                  width={130}
                  maxLength={10}
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtTotalAmount"
                  label="Total Amount"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtTotalAmount}
                  disabled={true}
                  width={120}
                  maxLength={10}
                />
              </Grid>
              <Grid item>
                <CtMultiLineText
                  id="txtRemark"
                  label="Remark"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtRemark}
                  width={300}
                  maxLength={500}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              marginTop={0}
              marginLeft={0}
            >
              <Grid
                item
                display={this.state.formData.int_status > 0 ? "none" : "block"}
              >
                <CtBtn
                  label="Save"
                  onClick={() => {
                    this.trimFormData(() => {
                      this.saveOrderData();
                    });
                  }}
                  disabled={this.state.formData.int_status == 0 ? false : true}
                />
              </Grid>
              <Grid item>
                <CtBtn label="New" onClick={this.clearInfo} />
              </Grid>
              <Grid
                item
                display={
                  (this.props.userPrivilege.Order !== "M") |
                  (this.state.formData.int_status > 0)
                    ? "none"
                    : "block"
                }
              >
                <CtBtn
                  label="Delete"
                  onClick={this.onDeleteBtnClick}
                  // disabled={this.state.formData.int_status == 0 ? false : true}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Order List"
                  onClick={() => {
                    this.props.navigateTo("OrderList");
                  }}
                />
              </Grid>{" "}
              {/* <Grid item>
                <CtBtn label="Add Customer" />
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>
        <br />
        <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          handleOnNewEntryClick={() => {
            this.trimFormData(this.handleOnNewEntryClick);
          }}
          // toolTipNewEntry="Order Item Entry"
        />

        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(OrderEntry))));
